import { connect } from "react-redux";

import InviteUserFormComponent from "./InviteUserFormComponent.jsx";
import {
  inviteUser,
  intializeDownloadReport,
} from "src/legacy/redux/actions/userManagement.jsx";
import { fetchUserRolesForAccount } from "src/legacy/redux/actions/userRoles.jsx";
import _ from "lodash";
import withUseHooks from "src/legacy/components/withUseHooks.jsx";

const mapStateToProps = (state, ownProps) => {
  return {
    inviting: _.get(state.legacyRootReducer.settings, "userManagement.inviting"),
    error: _.get(state.legacyRootReducer.settings, "userManagement.inviteError"),
    account: _.get(state, "account.item"),
    userRoles: _.get(state.legacyRootReducer, "userRoles.items", []),
    activeUsers: _.get(state, "users.users.activeUsers"),
    download: _.get(state.legacyRootReducer.settings, "userManagement.download"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    inviteUser: (user) => {
      return dispatch(inviteUser(user));
    },

    fetchUserRolesForAccount: () => {
      return dispatch(fetchUserRolesForAccount());
    },

    downloadReport: (id, request, page, limit) => {
      return dispatch(intializeDownloadReport(id, request, page, limit));
    },
  };
};

const InviteUserFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteUserFormComponent);

export default withUseHooks(InviteUserFormContainer);
